import ServicePage from "../ServicePage";
import { servicesData } from "@/mocks/services";

export default function LoiCarrezPage() {
  return <ServicePage data={servicesData["loi-carrez"]} />;
}
